// ============================================================
// 异步任务通知渲染
// 三种最终形态：
// - 提交/进行中：一次性 toast（见 asyncTask store 的 register()，直接用 ElMessage，不走本文件）
// - 成功：右侧常驻通知，绿色对勾，duration:0
// - 失败（后端明确失败 / 部分任务类型 2 小时放弃）：右侧常驻通知，红色叉形，duration:0
// ============================================================
import { h } from "vue";
import { ElNotification } from "element-plus";
import { CircleCheckFilled, CircleCloseFilled } from "@element-plus/icons-vue";
import { getRouter } from "@shared/router/router-instance";
import type { AsyncTaskNotifyAction, AsyncTaskNotifyContent } from "@shared/utils/asyncTaskHandlers";

function handleNotifyAction(action: AsyncTaskNotifyAction) {
    if (action.download) {
        window.open(action.download, "_blank");
        return;
    }
    if (action.to) {
        getRouter()?.push(action.to);
    }
}

function buildMessage(segments: AsyncTaskNotifyContent["segments"]) {
    return h(
        "div",
        { class: "ui-async-notify__message" },
        segments.map(seg => {
            if (typeof seg === "string") return seg;
            return h(
                "a",
                {
                    class: "ui-async-notify__link",
                    onClick: () => handleNotifyAction(seg),
                },
                seg.text,
            );
        }),
    );
}

/** 成功：绿色对勾图标，右侧常驻，用户手动关闭 */
export function notifyTaskSuccess(content: AsyncTaskNotifyContent) {
    return ElNotification({
        title: content.title,
        message: buildMessage(content.segments),
        duration: 0,
        customClass: "ui-async-notify ui-async-notify--success",
        icon: h(CircleCheckFilled, { class: "ui-async-notify__icon ui-async-notify__icon--success" }),
    });
}

/** 失败：红色叉形图标，右侧常驻，用户手动关闭 */
export function notifyTaskFailed(content: AsyncTaskNotifyContent) {
    return ElNotification({
        title: content.title,
        message: buildMessage(content.segments),
        duration: 0,
        customClass: "ui-async-notify ui-async-notify--failed",
        icon: h(CircleCloseFilled, { class: "ui-async-notify__icon ui-async-notify__icon--failed" }),
    });
}
